import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@chakra-ui/react';
import {
  VisibilityTableState,
  ColumnOrderTableState,
  GroupingTableState,
  ColumnSizingTableState,
  ColumnPinningTableState,
  SortingTableState,
  ExpandedTableState,
  PaginationTableState,
  RowSelectionTableState,
} from '@tanstack/react-table';
import React, { useState } from 'react';

import { TransactionsDailyAccountTotalsTable } from './TransactionsDailyAccountTotalsTable';
import { TransactionsDailyLineItemsTable } from './TransactionsDailyLineItemsTable';
import { TransactionsFilterState } from '~/packages/transactions/hooks/transactionsHooks';

// types
type TanstackTableState = Partial<
  VisibilityTableState &
    ColumnOrderTableState &
    ColumnPinningTableState &
    SortingTableState &
    ExpandedTableState &
    GroupingTableState &
    ColumnSizingTableState &
    PaginationTableState &
    RowSelectionTableState
>;

interface TransactionsViewProps {
  filterDerivedState: TransactionsFilterState;
  showBackToTopButton?: boolean;
  hasActiveFilters?: boolean;
  initialTanstackTableState?: TanstackTableState;
}

export const TransactionsView = ({
  filterDerivedState,
  showBackToTopButton = false,
  hasActiveFilters,
  initialTanstackTableState,
}: TransactionsViewProps) => {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <Tabs
      index={selectedTab}
      onChange={(index) => {
        setSelectedTab(index);
      }}
      width="100%"
    >
      <TabList>
        <Tab>Totals</Tab>
        <Tab>Line Items</Tab>
      </TabList>
      <TabPanels>
        <TabPanel p={0}>
          <TransactionsDailyAccountTotalsTable
            {...filterDerivedState}
            showBackToTopButton={showBackToTopButton}
            initialTanstackTableState={initialTanstackTableState}
            hasActiveFilters={hasActiveFilters}
          />
        </TabPanel>
        <TabPanel p={0}>
          <TransactionsDailyLineItemsTable
            {...filterDerivedState}
            showBackToTopButton={showBackToTopButton}
            initialTanstackTableState={initialTanstackTableState}
            hasActiveFilters={hasActiveFilters}
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
